<template>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalTitle">Add new brand</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        
        <form>
            <div v-if="form.id == 0" class="form-group">
                <label for="name">Subcategory Name</label>
                <input v-model="subName" type="text" class="form-control" id="name" placeholder="Subcategory Name" disabled>
            </div>
            <div v-if="form.id != 0" class="form-group">
                  <label>Select Category</label>             
                  <select v-model="form.subId" class="form-control" name="category">
                  <option v-for="sub in subcategories" :key="sub.id" :value="sub.id">             
                  {{
                    sub.name}}
                  </option>
                  </select>
              </div>
            <div class="form-group">
                <label for="brandname">Brand Name</label>
                <input v-model="form.name" type="text" class="form-control" id="brandname" placeholder="Brand Name" >
                <small v-if="error" class="errorMessage">{{errors.brand}}</small>
            </div>
            <div class="form-group">
                <label for="description">Brand Description</label>
                <textarea v-model="form.description" class="form-control" id="description" rows="3"></textarea>
                <small v-if="error" class="errorMessage">{{errors.description}}</small>
            </div> 
        </form>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button v-if="form.id == 0" type="button" class="btn btn-primary" @click="addbrand">Add subcategory</button>
        <button v-if="form.id != 0" type="button" class="btn btn-primary" @click="updatebrand">Update subcategory</button>
      </div>
    </div>
  </div>
  <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
            Loading
        },
    props:{
      form:Object,
      subName:String,
      Cid:Number
    },
    data(){
      return{
        fullPage:true,
        isLoading:false,
        error: false,
        errors: {},
        subcategories:[]
      }
    },
    created(){
      this.getSub();
    },
    methods:{
     
      getSub(){
        let path = 'admin/shopLocal/sub-category/' + this.Cid;
        this.axios.get(path)
        .then((response)=>{
          this.subcategories = response.data
        })
      },
      addbrand(){
        this.error = false;
        this.isLoading = true;
        this.axios.post('/admin/shopLocal/brands', {subcategory: this.form.subId, brand:this.form.name, description:this.form.description})
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'New Brand created',
                        })
         $('#exampleModal').modal('hide');
         this.form.name = '';
         this.form.description = '',
         this.$emit('reload');
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.errors = resp.response.data.errors;
        })
      },
      updatebrand(){
        this.error = false;
        this.isLoading = true;
        this.axios.patch('/admin/shopLocal/brands/' + this.form.id, {subcategory: this.form.subId, brand:this.form.name, description:this.form.description})
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'New Brand created',
                        })
         $('#exampleModal').modal('hide');
         this.form.name = '';
         this.form.description = '',
         this.$emit('reload');
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.errors = resp.response.data.errors;
        })
      }
      
     
    }
}
</script>
<style scoped>
  .errorMessage{
    color: red;
  }
</style>